module.exports = __webpack_public_path__ + "img/f9255e7b82572dbb5820b736c6c4cb99.png";